var BillingAddressView = (function (BaseView) {
	return BaseView.extend({
		el: '@newBillingAddress',

		errorClass: 'form-row__error',

		displayRoutes: ['checkout.address.billing'],

		template: 'bt-checkout-delivery-billing-form',

		events: {
			'click @btnAddBillingAddress': '_addBillingAddress',
			'keyup @txtBillingAddress': '_keyup'
		},

		initialize: function (opts) {
			_.bindAll(this, '_addBillingAddress', '_update', '_keyup', '_back', '_changed');

			this.opts = _.extend({
				backTo: 'checkout.address.form'
			}, opts);

			this.$el.html($.tmpl(this.template));
			this.$txtBillingAddress = this.$('@txtBillingAddress');
			this.$billingAddress = this.$('@billingAddress');

			this.model.on('change', this._changed);
		},

		beforeShow: function (opts) {
			this._backTo = opts && opts.backTo || this.opts.backTo || 'checkout';
			this.model.isActive(true);
		},

		afterHide: function () {
			this.model.isActive(false);
		},

		_changed: function() {
			this.$txtBillingAddress.val(this.model.get('Label'));
			this._update(this.model.toJSON());
		},
		_keyup: function(e) {
			this._update({ Label: e.currentTarget.value });
		},
		_update: function(address) {
			this.address = address;
			this._toggleError(false);
		},
		_toggleError: function (isError) {
			this.$billingAddress.toggleClass('form-row__error', isError);
			isError && this.$txtBillingAddress.focus();
		},
		_addBillingAddress: function() {
			this.model.save(this.address)
				.done(this._back)
				.fail(this._toggleError.bind(this, true));
		},
		_back: function() {
			this.display(this._displayRouter.getHistoryPrev());
		}
	});
})(BaseView);

var CurrentBillingAddressView = (function (BaseView) {
	return BaseView.extend({
		displayRoutes: ['checkout',
			'checkout.address.chooser',
			'checkout.address.form',
			'checkout.address.list'
		],

		events: {
			'click': '_click'
		},
		el: '@currentBillingAddress',
		initialize: function () {
			_.bindAll(this, '_render', '_toggle');
			this.model.on('change:Label saved', this._render);
			this.model.on('isActive', this._toggle);
		},

		_render: function () {
			var label = this.model.getLabel();
			this.$el.html($.tmpl('bt-checkout-delivery-billing', { Label: label })).toggle(!!label);
		},
		_toggle: function (isActive) {
			var label = this.model.get('Label');
			this.$el.toggle(!isActive && !!label);
		},
		_click: function () {
			this.display('checkout.address.billing');
		}
	});
})(BaseView);

var PickupPointFieldView = (function (BaseView, GetPageTemplate, CheckoutSettings) {
	return BaseView.extend({
		errorClass: 'form-row__error',

		events: {
			'click': '_showList'
		},

		initialize: function (opts) {
			_.bindAll(this, 'render', '_toggleShow', '_validation');

			this.opts = _.extend({
				backTo: 'checkout.address.form'
			}, opts);

			//this._pickupPoints = this.model.get('PickupPoints');

			this.listenTo(this.model, 'validation', this._validation);
			this.listenTo(this.model, 'selected clear', this.render);

			this.collection && this.listenTo(this.collection, 'deliveryTypeChange', this._toggleShow);

			this.render();
		},

		render: function () {
			this.$el.removeClass(this.errorClass);
			var selectedItem = this.model.getSelectedPickupPoint();
			if (selectedItem) {
				this.$el.html($.tmpl('bt-checkout-delivery-pickup', selectedItem).removeAttr('id').addClass('test-selected-pickup'));
				this.$_pickupLink = null;
			} else {
				this.$el.html($.tmpl('bt-checkout-delivery-pickup-select', {
					message: GetPageTemplate('_ChooseNearestPickupPoint')
				}));
				this.$_pickupLink = this.$el.children('@pickupPointChoose');
			}
		},

		_validation: function (status) {
			if (!this.$_pickupLink) {
				return;
			}

			if (status) {
				this.$el.removeClass(this.errorClass);
			} else {
				this.$el.addClass(this.errorClass);
			}
		},

		_toggleShow: function (type) {
			if (type === CheckoutSettings.addressDeliveryTypes.pickup) {
				this.show();
			} else {
				this.hide();
			}
		},

		_showList: function (e) {
			e.preventDefault();
			this.display('checkout.address.pickup.list', _.extend({
				model: this.model
			}, this.opts));
		}
	});
})(BaseView, kos.getPageTemplate, CheckoutSettings);

var PickupPointView = (function (_, BaseView) {

	var PickupPointView = BaseView.extend({

		selectedClass: 'bt-pickup-point-selected',

		events: {
			'click': 'select'
		},

		initialize: function (opts) {
			_.bindAll(this, 'render', 'remove');

			this.opts = opts || {};

			this.listenTo(this.model, 'change', this.render);
			this.listenTo(this.model, 'remove', this.remove);
		},

		select: function (e) {
			e.preventDefault();
			this.model.select();
			this.display(this.opts.backTo || 'checkout.address.form');
		},

		render: function () {
			this.$el.html($.tmpl('bt-checkout-delivery-pickup', this.model.toJSON()))
				.toggleClass(this.selectedClass, this.model.isSelected());
			return this;
		}
	});

	return PickupPointView;
})(_, BaseView);

var PickupPointsView = (function (_, BaseView, PickupPointView, GetPageTemplate) {

	var PickupPointsView = BaseView.extend({

		el: '#bt-checkout-pickup-point-list',

		initialize: function (opts) {
			_.bindAll(this, 'render');

			this.opts = opts || {};

			this.listenTo(this.collection, 'sync error', this.render);
		},

		render: function () {
			if (this.collection.length) {
				var rendered = [],
					_this = this;
				this.collection.each(function (model) {
					rendered.push(new PickupPointView(_.extend({
						model: model
					}, _this.opts)).render().el);
				});
				this.$el.html(rendered);
			} else {
				this.$el.html($.tmpl('bt-checkout-delivery-pickup-nothing-found', {
					message: GetPageTemplate('_NoPointsCheckPostCode')
				}));
			}
		}
	});

	return PickupPointsView;
})(_, BaseView, PickupPointView, kos.getPageTemplate);

var ChoosePickupPointView = (function (_, BaseView, FieldView, PickupPointsView) {
	var ChoosePickupPointView = BaseView.extend({
		el: '#bt-checkout-pickup-points',

		displayRoutes: ['checkout.address.pickup.list'],

		/*
		events: {
			'click #bt-checkout-pickup-point-no-need': '_setNoNeed'
		},
		*/

		initialize: function () {
			this._pickupPoints = this.model.get('PickupPoints');
			this._postcode = this.model.get('Postcode');
		    this._postcode.set('Label', 'Enter postcode to find nearest Pickup Point');
			this.disabled = !this.model.isEnabled();
			this.model.on('change:IsPickupPointsEnabled', _.bind(function() {
				this.disabled = !this.model.isEnabled();
			}, this));

			this._initPickupPoints();
		},

		beforeShow: function (opts) {
			BaseView.prototype.beforeShow.apply(this, arguments);

			opts = _.extend({
				model: null,
				backTo: 'checkout.address.form'
			}, opts);

			this._backTo = opts.backTo;
			opts.model && (this.model = opts.model) && this.initialize();

			this._renderPostcodeField();
			this._renderPickupPoints();
		},

		afterDisplay: function() {
		    this._postcodeField && 
		        this._postcodeField.focus && 
		        this._postcodeField.focus();
		},

		afterHide: function () {
			BaseView.prototype.afterHide.apply(this, arguments);
			//this.model.restoreStateBySelectedPickupPoint();
		},

		_initPickupPoints: function () {
			var settings = CheckoutSettings.getBasketSettings();
			if (!this.pickupPointsHelper) {
				this.pickupPointsHelper = new PickupPointsHelper({
					/* API Key*/
					key: settings.PickupPointsMapToken,

					/* Elements */
					el: this.$('@pickupPointsContainer')[0],
					switcher: this.$('@pickupViewModeSwitcher')[0],
					mapTab: this.$('@pickupViewModeSwitcher-map')[0],
					listTab: this.$('@pickupViewModeSwitcher-list')[0],
					mapCanvas: this.$('@pickupPointsMap')[0],
					pickupListCanvas: this.$('@pickupPointsList')[0],

					/* Class to hide elements */
					hiddenClassName: 'hidden-block',

					displayMap: settings.PickupPointsMapEnabled,

					/* Default country ID and Zoom settings */
					countryID: GlobalSettings.Iso.toUpperCase(),

					/* Callback on select PP event */
					selectCallback: this._selectPickupPoint.bind(this),

					/* Html Templates */
					getMarkerInfoHtml: function (data) {
						return $.tmpl('bt-checkout-delivery-pickup-marker-info', data)[0].outerHTML;
					},
					getPickupInfoHtml: function (data) {
						return $.tmpl('bt-checkout-delivery-pickup', data)[0].outerHTML;
					},
					getNoPickupMessageHtml: function () {
						return $.tmpl('bt-checkout-delivery-pickup-not-found-message')[0].outerHTML;
					},
					coordinates_changed: this.model.fetch.bind(this.model)
				});

				this.pickupPointsHelper.hide();

				this.model.on('syncByPostcode', function (pickupPoints) {
					this.pickupPointsHelper.setPickupPoints(pickupPoints, true);
				}.bind(this));

				this.model.on('syncByCoordinates', function (pickupPoints) {
					this.pickupPointsHelper.setPickupPoints(pickupPoints, false);
				}.bind(this));

				this.model.on('clear', function (pickupPoints) {
					this.pickupPointsHelper.clear();
				}.bind(this));
			}
		},

		_selectPickupPoint: function (data) {
			this.model.setSelectedPickupPoint(data);
			if ($.isFunction(this.moveTo)) {
				this.moveTo();
			} else {
				this.display(this._backTo || 'checkout.address.form');
			}
		},

		_getPickupPointsByCoordinates: function (data) {
			this.model.fetch(data);
		},

		/*
		_setNoNeed: function() {
			this._pickupPoints.unselectModel();
			this.display(this._backTo);
		},
		*/

		_renderPostcodeField: function () {
			this._postcodeField && this._postcodeField.remove();
			this._postcodeField = new FieldView({ model: this._postcode });
			this.$el.children('#bt-checkout-pickup-point-postcode').html(this._postcodeField.$el);
		},

		_renderPickupPoints: function () {
			//this._pickupPointsView && this._pickupPointsView.remove();
			//this._pickupPointsView = new PickupPointsView({
			//	collection: this._pickupPoints,
			//	backTo: this._backTo
			//}).render();
		}
	});

	return ChoosePickupPointView;
})(_, BaseView, FieldView, PickupPointsView);


var AddDeliveryAddressButtonBaseView = (function (BaseView) {
	return BaseView.extend({

		events: {
			'click': '_onClick'
		},

		initialize: function (opts) {
			this.opts = opts || {};
			this._backTo = this.opts.backTo;
		},

		render: function () {
			this.$el.append($.tmpl(this.tmplName, this.opts));
			return this;
		},

		_onClick: function () {
			throw new Error('Not implemented error');
		},

		_backTo: null
	});
})(BaseView);

var AddDeliveryAddressButtonPickupPointView = (function (AddDeliveryAddressButtonBaseView, CheckoutSettings) {
	return AddDeliveryAddressButtonBaseView.extend({
		tmplName: 'bt-checkout-new-delivery-btn-pickup',

		_onClick: function (e) {
			e.preventDefault();
            if (this.opts.isEnabled) {
                window.app && app.event && app.event.chooseAddressTypePickupPoint();
				this.display('checkout.address.form', {
					backTo: this._backTo,
					deliveryType: CheckoutSettings.addressDeliveryTypes.pickup
				});
			}
		}
	});
})(AddDeliveryAddressButtonBaseView, CheckoutSettings);

var AddDeliveryAddressButtonSignatureView = (function (AddDeliveryAddressButtonBaseView, CheckoutSettings) {
	return AddDeliveryAddressButtonBaseView.extend({
		tmplName: 'bt-checkout-new-delivery-btn-signature',

		_onClick: function (e) {
            e.preventDefault();
		    window.app && app.event && app.event.chooseAddressTypeSimple();
			this.display('checkout.address.form', {
				backTo: this._backTo,
				deliveryType: CheckoutSettings.addressDeliveryTypes.signature
			});
		}
	});
})(AddDeliveryAddressButtonBaseView, CheckoutSettings);

var AddDeliveryAddressButtonSimpleView = (function (AddDeliveryAddressButtonBaseView, CheckoutSettings) {
    return AddDeliveryAddressButtonBaseView.extend({

        tmplName: 'bt-checkout-new-delivery-btn-simple',

        _onClick: function (e) {
            e.preventDefault();
            window.app && app.event && app.event.chooseAddressTypeSimple();
            this.display('checkout.address.form', {
                backTo: this._backTo,
                deliveryType: null
            });
        }
    });
})(AddDeliveryAddressButtonBaseView, CheckoutSettings);

var AddDeliveryAddressChooserView = (function (AddDeliveryAddressButtonPickupPointView, AddDeliveryAddressButtonSignatureView, CheckoutSettings) {
	return BaseView.extend({
        className: 'page-block-wrapper',
		initialize: function (opts) {
			this.opts = _.extend({
				signature: false,
				backTo: null
			}, opts || {});
			this._backTo = this.opts.backTo;
			this.listenTo(this.collection.pickupPointField, 'change:IsPickupPointsEnabled', this.render);
		},

		render: function () {
			this._pickupView && this._pickupView.remove();
			this._signatureView && this._signatureView.remove();

            this.$el.empty();

            if (this.opts.signature) {
				this._signatureView = new AddDeliveryAddressButtonSignatureView({
					collection: this.collection,
					backTo: this._backTo
				});
                this._signatureView.render();
                this.$el.append(this._signatureView.$el);
			} else {
				this._signatureView = new AddDeliveryAddressButtonSimpleView({
					collection: this.collection,
                    backTo: this._backTo
				});
                this._signatureView.render();
                this.$el.append(this._signatureView.$el);
			}

			if (this._isPickupPointEnabledInCountry()) {
				this._pickupView = new AddDeliveryAddressButtonPickupPointView({
					collection: this.collection,
					backTo: this._backTo,
					isEnabled: this._isPickupPointsEnabled()
				});
                this._pickupView.render();
                this.$el.append(this._pickupView.$el);
            }

			return this;
		},

		_isPickupPointsEnabled: function() {
			return this.collection.isPickupPointsEnabled();
		},

		_isPickupPointEnabledInCountry: function () {
			var settings = CheckoutSettings.getBasketSettings();
			return settings.PickupPointsEnabled;
		},

        _isGiftEnabled: function () {
			var settings = CheckoutSettings.getBasketSettings();
            return settings.GiftEnabled;
		},

		_backTo: null
	});
})(AddDeliveryAddressButtonPickupPointView, AddDeliveryAddressButtonSignatureView, CheckoutSettings);

/* Looks like this is part do not needed */
var AddDeliveryAddressChooserPageView = (function (AddDeliveryAddressChooserView, CheckoutSettings) {
	return AddDeliveryAddressChooserView.extend({
		displayRoutes: ['checkout.address.chooser'],

		el: '@addressChooser',

		initialize: function () {
			AddDeliveryAddressChooserView.prototype.initialize.apply(this, arguments);
			this.render();
		},

		beforeShow: function (data) {
			AddDeliveryAddressChooserView.prototype.beforeShow.apply(this, arguments);
			this._backTo = data && data.backTo;
		}
	});
})(AddDeliveryAddressChooserView, CheckoutSettings);


var AddDeliveryAddressDisplayCommand = (function (RoutedView, getPageTemplate, CheckoutSettings, GlobalSettings) {
    return RoutedView.extend({
        initialize: function (opts) {
            opts = opts || {};
            this._backTo = opts.backTo;
            this.isPickupPointsEnabled = false;
        },

        invoke: function () {
            if (this.isPickupPointsEnabled && GlobalSettings.SATL) {
                this.display('checkout.address.chooser', {
                    backTo: this._backTo
                });
            } else if (this.isPickupPointsEnabled) {
                this.display('checkout.address.form', {
                    backTo: this._backTo,
                    deliveryType: CheckoutSettings.addressDeliveryTypes.pickup
                });
            } else if (GlobalSettings.SATL) {
                this.display('checkout.address.form', {
                    backTo: this._backTo,
                    deliveryType: CheckoutSettings.addressDeliveryTypes.signature
                });
            } else {
                this.display('checkout.address.form', {
                    backTo: this._backTo,
                    deliveryType: null
                });
            }
		},

		invokeGift: function (_backTo) {
            _backTo = _backTo || 'checkout';
			var _this = this;

            this.display('checkout.address.gift.address.message.form',
                {
                    callback: function() {
                        _this._displayRouter.removeLatest();
						_this.display(_backTo);
                    }
                });
		},

		invokeBilling: function (_backTo) {
			this.display('checkout.address.billing.form', {
				backTo: _backTo || this._backTo
            });
		},

		invokeGiftAndBilling: function (_backTo) {
            _backTo = _backTo || 'checkout';
			var _this = this;
			var $giftAdded = new $.Deferred();
            var $billingAdded = new $.Deferred();

			this.display('checkout.address.gift.address.message.form', {
				callback: $giftAdded.resolve
			});

			$giftAdded.promise().then(function () {
                _this._displayRouter.removeLatest();
				_this.display('checkout.address.billing.form', {
					callback: $billingAdded.resolve
                });
            });

			$billingAdded.promise().then(function () {
				_this._displayRouter.removeLatest();
				_this.display(_backTo);
            });
        }


    });
})(RoutedView, kos.getPageTemplate, CheckoutSettings, GlobalSettings);

var AuthToLeaveView = (function (BaseView, GetPageTemplate) {
	return BaseView.extend({
		el: '@authToLeaveSelect',

		displayRoutes: ['checkout.address.auth'],

		selectedClass: 'sod-item-list-option__selected',

		events: {
			'click @instruction': 'choose',
			'click @sodNeed': '_sodNeed'
		},

		instructions: [
            GetPageTemplate('_AuthToLeave_Instruction_1'),
            GetPageTemplate('_AuthToLeave_Instruction_2'),
            GetPageTemplate('_AuthToLeave_Instruction_3'),
            GetPageTemplate('_AuthToLeave_Instruction_4'),
            GetPageTemplate('_AuthToLeave_Instruction_5'),
            GetPageTemplate('_AuthToLeave_Instruction_6')
		],

		initialize: function () {
			this.$el.html($.tmpl('bt-checkout-delivery-sod-instructions', { Instructions: this.instructions }));
		},

		choose: function (e) {
			e.preventDefault();
			var inst = $(e.currentTarget).data('inst');
			this.display('checkout.address.auth.confirm', { authComment: inst, model: this.model, backTo: this.backTo });
		},

		beforeShow: function (data) {
			this.model = data.model;
			this.backTo = data.backTo;
			this.$('@instruction').removeClass(this.selectedClass);
			$('@instruction[data-inst="' + this.model.getAuthComment() + '"]').addClass(this.selectedClass);
		},

		_sodNeed: function () {
			this.model.cancelSignature();
			this.display(this.backTo);
		}
	});
})(BaseView, kos.getPageTemplate);

var AuthToLeaveConfirmView = (function (BaseView) {
	return BaseView.extend({
		el: '@authToLeaveConfirm',
		displayRoutes: ['checkout.address.auth.confirm'],
		events: {
			'click @acceptButton': 'accept'
		},
		beforeShow: function (data) {
			this.$('@txtInstructions').val(data.authComment);
			this.model = data.model;
			this.backTo = data.backTo;
		},
		afterShow: function () {
			var prev = this._displayRouter.getHistoryPrev();
			if (prev) {
				this.setBackCallback(_.bind(function () {
					this.display('checkout.address.auth', { model: this.model, backTo: this.backTo });//tbd: save path with arguments in router
				}, this));
			}
		},
		accept: function (e) {
			e.preventDefault();
			var inst = this.$('@txtInstructions').val();
			if (inst) {
				this.$('@txtInstructions').removeClass('errorField');
				this.model.applySignature(inst);
				this.display(this.backTo);
			} else {
				this.$('@txtInstructions').addClass('errorField');
			}
		}
	});
})(BaseView);

var SignatureView = (function (BaseView, getPageTemplate) {
	return BaseView.extend({
		errorClass: 'form-row__error',

		events: {
			'click': '_onClick'
		},

		initialize: function (opts) {
			_.bindAll(this, 'render', '_toggleShow'/* , '_authValidation' */);

			opts = opts || {};
			this._backTo = opts.backTo;

			this.listenTo(this.model, 'change:AuthComment', this.render);
			this.listenTo(this.model, 'deliveryTypeChange', this._toggleShow);
			//this.listenTo(this.model, 'authCommentValidation', this._authValidation);

			this.render();
		},

		render: function () {
			this.$el.html($.tmpl('bt-checkout-delivery-sod', {
				message: this.model.getAuthComment() || getPageTemplate('_SignatureOnDelivery')
			}));
		},

		/*
		_authValidation: function (status) {
			if (status) {
				this.$el.children('@sodSelect').removeClass(this.errorClass);
			} else {
				this.$el.children('@sodSelect').addClass(this.errorClass);
			}
		},
		*/

		_toggleShow: function (type) {
			if (type === CheckoutSettings.addressDeliveryTypes.signature) {
				this.show();
			} else {
				this.hide();
			}
		},

		_onClick: function (e) {
			e.preventDefault();
			this.display('checkout.address.auth', { model: this.model, backTo: this._backTo });
		}
	});
})(BaseView, kos.getPageTemplate);

var AddressFormView = (function (BaseView, FieldView, SignatureView, PickupPointFieldView, GetPageTemplate, GlobalSettings) {
	return BaseView.extend({
		el: '@newAddress',

		displayRoutes: ['checkout.address.form'],

		events: {
			'click @btnAddAddress': 'addAddress'
		},

		initialize: function () {
		    _.bindAll(this, '_pcaAutofill', '_toggleDeliveryType');

			this.$fields = this.$('@fields');

			this._initSignature();
			this._initPickupPointField();

			this.render();
			this.listenTo(this.collection, 'add', _.bind(this._renderField, this));
		    this.listenTo(this.collection, 'update', _.bind(this._pcaLoad, this));
		    this.listenTo(this.collection, 'deliveryTypeChange', this._toggleDeliveryType);

		},

		render: function () {
			this.collection.each(_.bind(this._renderField, this));
		},

		addAddress: function (e) {
            e.preventDefault();
		    window.app && app.event && app.event.useThisAddress();
			this.collection
                .save()
                .done(_.bind(this._saved, this))
                .fail(_.bind(this._failed, this));
		},

		beforeShow: function (data) {
			this._backTo = data ? data.backTo : null;
			this._onSavedCallback = data ? data.callback : null;
			data && this.collection.setDeliveryType(data.deliveryType);
		},

		_renderField: function (model) {
			var field = new FieldView({ model: model });
			this.$fields.append(field.$el);
		},

		_saved: function (data) {
			if (this._onSavedCallback) {
				this._onSavedCallback();
			}
			
			var pixel = this.options.pixel;
			pixel && pixel.trigger(data.Value);

			this.display(this._backTo || 'checkout');
		},

		_failed: function () {
			alert(GetPageTemplate('_FillAllFields'));
		},

		_initPickupPointField: function () {
			this.collection.pickupPointField && new PickupPointFieldView({
				el: this.$el.find('@pickup'),
				model: this.collection.pickupPointField,
				collection: this.collection,
				backTo: 'checkout.address.form'
			});
		},

		_initSignature: function () {
			this.$signature = new SignatureView({
				model: this.collection,
				backTo: 'checkout.address.form'
			}).$el.show();
			this.$('@signature').append(this.$signature);
		},

		_toggleDeliveryType: function (type) {
		    //this.type = type;
		    this.$('@signature').toggleClass('hidden-block', type !== CheckoutSettings.addressDeliveryTypes.signature);
		    this.$('@pickup').toggleClass('hidden-block', type !== CheckoutSettings.addressDeliveryTypes.pickup);
            this.collection.each(function(model) {
                var name = model.get('Name') || '';
                var isHidden = !(type !== CheckoutSettings.addressDeliveryTypes.pickup || name.match(/^(Name|Phone)$/i));
                model.setHidden(isHidden);
            });
		},

		_pcaLoad: function () {
		    var settings = CheckoutSettings.getBasketSettings();

		    if (settings.PcaEnabled && !settings.GoogleAddressSuggestionEnabled) {
		        var fields = this.collection.filter(function (m) {
		            return m.get('Suggestion');
		        }).map(function (m) {
		            var s = m.get('Suggestion');
		            return { element: m.get('Name'), field: s.Field, mode: s.Mode };
		        });

		        var options = {
		            key: settings.PcaAPIID,
		            search: { countries: GlobalSettings.Iso }
		        };

		        pcaApi.ready(_.bind(function() {
		            this.control = pcaApi.newControl(fields, options, this._pcaAutofill);
		        }, this));
		    }
		},

		_pcaAutofill: function () {
		    setTimeout(_.bind(function() {
		        this.collection.pcaUpdateModel();
		    }, this), 500);
		}
	});
})(BaseView, FieldView, SignatureView, PickupPointFieldView, kos.getPageTemplate, GlobalSettings);

var AddressView = (function (BaseView) {
	return BaseView.extend({
		events: {
			'click': 'select'
		},

		initialize: function (opts) {
			this.listenTo(this.model, 'change', _.bind(this.render, this));
			this.listenTo(this.model, 'remove', _.bind(this.remove, this));
			this.listenTo(opts.pickupPoint, 'change:IsPickupPointsEnabled', _.bind(this._togglePickupPoint, this));
			this.pickupPoint = opts.pickupPoint;
			this.render();
		},

        select: function () {
            window.app && app.event && app.event.useAnotherAddress();
			this.model.select().done(_.bind(this._selected, this));
		},

		_selected: function () {
			this.display('checkout');
		},

		render: function () {
		    var address = this.model.toJSON();
		    var pickupPoint = this.model.get('pickupPoint').toJSON();
            if (this.model.get('pickupPoint').get('ID')) {
                pickupPoint.Recipient = address.Name;
                pickupPoint.Phone = address.Phone;
                this.$pickupPointEl = $.tmpl('bt-checkout-delivery-address-pickup', pickupPoint);
                this.$el = this.$pickupPointEl;
                this.$pickupPointEl.hide();
            } else {
                this.$el = $.tmpl('bt-checkout-delivery-address', address);
            }

			// TBD: ??? no @sod in the template.
			if (GlobalSettings.SATL && this.model.get('AuthToLeave')) { //tbd: use constant in one place
				this.$('@sod').show();
			}

            this._togglePickupPoint();
		},

		_togglePickupPoint: function() {
			this.$pickupPointEl && this.$pickupPointEl.toggle(this.pickupPoint.isEnabled());
		}
	});
})(BaseView);

var AddressesView = (function (BaseView, AddressView, PickupPointFieldView, GetPageTemplate, GlobalSettings) {
	return BaseView.extend({
		el: '@changeAddress',

		displayRoutes: ['checkout.address.list'],

		initialize: function (opts) {
			this.collectionForm = opts.collectionForm;

			this.listenTo(this.collection, 'update', _.bind(this._render, this));
			this.listenTo(this.collection, 'isValid', _.bind(this._onValidation, this));

			this.$addressesList = this.$('@addressesList');
			this.$btnNewAddress = new AddDeliveryAddressChooserView({
				signature: GlobalSettings.SATL,
                collection: opts && opts.collectionForm,
                //deliveryModeSwitcher: opts.deliveryModeSwitcher
			});
			this.$el.append(this.$btnNewAddress.render().el);
		},

		beforeShow: function () {
			this.collection.fetch();
		},

		_render: function (collection) {
			var rendered = [];
			var pickupPointField = this.collectionForm.pickupPointField;
			collection.each(function (m) {
				rendered.push(new AddressView({ model: m, pickupPoint: pickupPointField }).$el);
			});
			this.$addressesList.html(rendered);
		},

		_onValidation: function (obj, value) {
			if (value) {
				return;
			}

			alert(GetPageTemplate('bi_PleaseChoseAnotherOrAddNewAddress'));
		}
	});
})(BaseView, AddressView, PickupPointFieldView, kos.getPageTemplate, GlobalSettings);

var DeliveryView = (function (BaseView, SignatureView, PickupPointFieldView, AddDeliveryAddressChooserView, DeliveryOptions) {
	return BaseView.extend({
		el: '@delivery',

		events: {
			'click @delivery-address': 'displayList'
		},

		initialize: function () {
			_.bindAll(this, 'render', '_showPPAddress', '_optionChanged');

            this.$btnNewAddress = new AddDeliveryAddressChooserView({
				signature: GlobalSettings.SATL,
				collection: this.model.form(),
                className: '',
                deliveryModeSwitcher: this.model.deliveryModeSwitcher()
			});

			this.$el.append(this.$btnNewAddress.render().el);

			this.listenTo(this.model, 'update', this.render);
		},

		_initDeliveryOptions: function () {
			//this.deliveryOptions = new DeliveryOptions(window.toMoney, GlobalSettings.CurrencySign, this._optionChanged);
			//this.deliveryOptions.appendTo('#delivery-options');
		},

		render: function () {

		    var hasCurrentAddress = this.model.hasCurrent();

		    //this.deliveryOptions.clear();

		    if (hasCurrentAddress) {
				if (this.$address) {
					this.$address.remove();
				}

				// TBD: address view should be used here.

		        var current = this.model.current().toJSON();

				// TBD: pickup point model should be in current address.
				var currentPickup = this.model.isPickupPointsEnabled() && this.model.pickupPointField().getSelectedPickupPoint();

                if (currentPickup) {
                    currentPickup.Recipient = current.Name;
                    currentPickup.Phone = current.Phone;
                    this.$address = $.tmpl('bt-checkout-delivery-address-pickup', currentPickup);
                } else {
                    this.$address = $.tmpl('bt-checkout-delivery-address', current);
                }

				this.$el.prepend(this.$address);

				this.$btnNewAddress.hide();
				if (this.signatureView) {
					this.signatureView.remove();
				}
                if (GlobalSettings.SATL && !currentPickup) { //tbd: use constant in one place
                    this.signatureView = new SignatureView({ model: this.model.current(), backTo: 'checkout' });
                    $('#bt-checkout-address-sod').html(this.signatureView.$el).removeClass('hidden-block');
                } else {
                    $('#bt-checkout-address-sod').addClass('hidden-block');
                }
			} else {
				this.$btnNewAddress.show();
		        $('#bt-checkout-address-sod').addClass('hidden-block');
			}
		},

		_optionChanged: function (data) {
			data && this.model.current().setDeliveryOption(JSON.stringify(data));
		},

		displayList: function (e) {
            e.preventDefault();
		    window.app && app.event && app.event.changeAddress();
            this.display('checkout.address.list');
		},
		_showPPAddress: function () {
		    var isPPAvailable = this.model.isPickupPointsEnabled();
		    if (isPPAvailable) {
		        api.sendPPAddressPromoLabelClickedEvent();
                this.display('checkout.address.form', {
		            backTo: this._backTo,
		            deliveryType: CheckoutSettings.addressDeliveryTypes.pickup
		        });
		        
		    }
		},

        _isGiftEnabled: function () {
            var settings = CheckoutSettings.getBasketSettings();
            return settings.GiftEnabled;
        }
	});
})(BaseView, SignatureView, PickupPointFieldView, AddDeliveryAddressChooserView, DeliveryOptions);

var OpsInfoView = (function (BaseView) {
    return BaseView.extend({
        displayRoutes: ['checkout.ops.info'],

        el: '@ops-info-container',

        beforeShow: function (data) {
            this._backTo = 'checkout';
            this.$el.html($.tmpl('ops-info', data));
        }
    });
})(BaseView);

var deliveryModule = (function (AuthToLeaveView, AuthToLeaveConfirmView, AddressFormView, AddressGiftFormView, AddressBillingFormView, AddressesView, DeliveryView, ChoosePickupPointView, AddDeliveryAddressDisplayCommand, BillingAddressView, CurrentBillingAddressView, OpsInfoView, GlobalSettings) {
	return function (model, shippingInfoPixel) {
		if (!model) return;
		model.form().pickupPointField.on('change:IsPickupPointsEnabled', function () {
			AddDeliveryAddressDisplayCommand.isPickupPointsEnabled = model.form().pickupPointField.isEnabled();
		});

        new OpsInfoView();

		new AuthToLeaveView();
		new AuthToLeaveConfirmView();

        var addressFormView = new AddressFormView({ collection: model.form(), pixel: shippingInfoPixel });

        var _deliveryModeSwitcher = model.deliveryModeSwitcher();

        GiftDeliveryChooserView(model);

		new BuyAsGiftButtonView({ model: model });

		new AddressesView({
			collection: model.addresses(),
            collectionForm: model.form(),
            //deliveryModeSwitcher: _deliveryModeSwitcher
		});

		var settings = CheckoutSettings.getBasketSettings();

		var ppView = new ChoosePickupPointView({ model: model.form().pickupPointField });

		if (settings.BillingAddressEnabled) {
			var billingModel = model.billingAddress();
			new BillingAddressView({ model: billingModel });
			new CurrentBillingAddressView({ model: billingModel });

			model.form().preValidate = function () {
				var hasBilling = billingModel.hasBilling();
				!hasBilling && addressFormView.display('checkout.address.billing');
				return hasBilling;
			};

			ppView.moveTo = function () {
				var hasBilling = billingModel.hasBilling();
				this.display(hasBilling ? 'checkout.address.form' : 'checkout.address.billing');
			}.bind(ppView);
		}

		new AddDeliveryAddressChooserPageView({
			signature: GlobalSettings.SATL,
			collection: model.form(),
            //deliveryModeSwitcher: _deliveryModeSwitcher
		});

		return new DeliveryView({ model: model });
	};
})(AuthToLeaveView, AuthToLeaveConfirmView, AddressFormView, AddressGiftFormView, AddressBillingFormView, AddressesView, DeliveryView, ChoosePickupPointView, AddDeliveryAddressDisplayCommand, BillingAddressView, CurrentBillingAddressView, OpsInfoView, GlobalSettings);
